import { Grid, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { Field, FieldArray, Form, Formik } from "formik";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import messages from "../../../assets/locale/messages";
import BookCover from "../../../components/BookCover";
import Button from "../../../components/Button";
import Checkbox from "../../../components/Checkbox";
import DatePicker from "../../../components/DatePicker";
import Input from "../../../components/Input";
import CustomSelect from "../../../components/Select";
import Switch from "../../../components/Switch";
import Upload from "../../../components/Upload";
import UploadImg from "../../FinalTests/FinalTestForm/finalTestImageUploading";
import userPhoto from "../../../assets/images/userPhoto.png";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteModal from "../../../components/DeleteModal";
import {
  addBookRequest,
  editBookRequest,
  getBooksRequest,
  getSingleBookRequest,
  getSingleBookResponse
} from "../../../store/Books/actions";
import { getCategoriesRequest } from "../../../store/Categories/actions";
import { showHideLoader } from "../../../store/Loader/actions";
import {
  CERTIFICATE_TYPES,
  getLocalORPublicSrc
} from "../../../utils/Constants";
import { uploadToS3 } from "../../../utils/S3";
import styles from "./BookForm.module.scss";
import { ADD_BOOK_SCHEMA, getInitialValues } from "./validations";

const BookForm = () => {
  const formRef = useRef();
  const SamplesRef = useRef(null);
  const [samplesArray, setSamplesArray] = useState(
    formRef?.current?.values?.["book_samples_attributes"] || []
  );

  useEffect(() => {
    if (formRef?.current?.values?.["book_samples_attributes"]) {
      setSamplesArray(
        formRef.current.values["book_samples_attributes"]
      );
    }
  }, [formRef?.current?.values]);

  const handleChange = (e) => {
    const SamplesName = SamplesRef.current.name;
    const newFiles = Array.from(e.target.files);
    const updatedSamples = [
      ...samplesArray,
      ...newFiles.map((file) => ({
        sample_url: URL.createObjectURL(file), // Local preview URL
        file, // Store the actual file for upload
        _destroy: false
      }))
    ];

    setSamplesArray(updatedSamples);
    formRef.current.setFieldValue(SamplesName, updatedSamples);
  };

  const RemoveImgOfSamplesHandler = (index) => {
    const SamplesName = SamplesRef.current.name;

    // Mark the sample for deletion
    const updatedSamples = samplesArray.map((sample, i) => {
      if (i === index) {
        return {
          ...sample,
          _destroy: true
        };
      }
      return sample;
    });

    const filteredSamples = updatedSamples.filter(
      (item) => !(item._destroy === true && item.id === undefined)
    );

    setSamplesArray(filteredSamples);
    formRef.current.setFieldValue(SamplesName, filteredSamples);
  };

  let params = useParams();
  const theme = useTheme();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.locale.lang);
  const categoriesList = useSelector(
    (state) => state.categories.list
  );

  const booksInCategoryList = useSelector(
    (state) => state.books.list
  );

  const singleBook = useSelector((state) => {
    return state.books.singleBook?.certificate
      ? _.merge(
          state.books.singleBook,
          _.omit(
            {
              ...state.books.singleBook?.certificate,
              certificateId: state.books.singleBook?.certificate?.id
            },
            ["id"]
          )
        )
      : state.books.singleBook;
  });

  const [bookCoverPreview, setBookCoverPreview] = useState(null);

  const [mode, setMode] = useState("add");
  console.log("mode", mode);

  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [booksInCategoryOptions, setBooksInCategoryOptions] =
    useState([]);
  useEffect(() => {
    if (params?.id) {
      getBooksInCategory();
    }

    getCategories({
      paginate: false
    });
    return () => {
      dispatch(getSingleBookResponse({}));
    };
  }, []);
  const getCategories = (params) => {
    dispatch(getCategoriesRequest(params));
  };
  const getBooksInCategory = () => {
    dispatch(getBooksRequest({ paginate: false }));
  };
  useEffect(() => {
    if (categoriesList.length) {
      setCategoriesOptions(
        categoriesList.map(({ id, name }) => ({
          id,
          value: name,
          label: name
        }))
      );
    }
  }, [categoriesList]);

  useEffect(() => {
    if (params?.id) {
      setMode("edit");
      dispatch(getSingleBookRequest(params?.id));
    } else {
      return null;
    }
  }, [params]);

  useEffect(() => {
    if (mode === "edit") {
      setBookCoverPreview(singleBook?.cover_photo);
    }
  }, [singleBook]);

  useEffect(() => {
    setBooksInCategoryOptions(
      booksInCategoryList?.map(({ id, title }) => ({
        id,
        value: title,
        label: title
      }))
    );
  }, [booksInCategoryList]);

  const handleSubmit = async ({
    certificate_description,
    credit_type,
    certificate_title,
    credits,
    submission_date,
    publish_students,
    publish_authors,
    published,
    ...values
  }) => {
    dispatch(showHideLoader(true));
    let publishStatus = "";
    if (published) {
      publishStatus = publish_students
        ? publish_authors
          ? "authors_students"
          : "students"
        : publish_authors
        ? "authors"
        : "not_published";
    }
    if (mode === "add") {
      let addBookData =
        certificate_title || credits
          ? {
              ...values,
              certificate_attributes: {
                certificate_description,
                certificate_title,
                credit_type,
                credits,
                submission_date
              }
            }
          : _.omit(values, [
              "certificate_description",
              "certificate_title",
              "credit_type",
              "credits",
              "submission_date",
              "publish_students",
              "publish_authors",
              "published"
            ]);

      addBookData = { ...addBookData, publish_state: publishStatus };
      const updatedSamples = await Promise.all(
        addBookData.book_samples_attributes.map(async (sample) => {
          if (sample._destroy) {
            return { _destroy: true, id: sample.id };
          }
          try {
            if (sample.file) {
              const result = await uploadToS3(
                "public",
                sample.file,
                sample.file.name
              );
              return { sample_url: result.link };
            }
            return sample;
          } catch (error) {
            console.error(
              `Failed to upload ${sample.sample_url} to S3:`,
              error
            );
            return sample;
          }
        })
      );

      // Update book_samples_attributes with the processed samples
      addBookData.book_samples_attributes = updatedSamples;

      if (values.front_matter) {
        uploadToS3(
          "public",
          values.front_matter,
          values.front_matter.name
        ).then((res) => {
          addBookData.front_matter = res.link;
        });
      }
      if (values.faculty) {
        uploadToS3(
          "public",
          values.faculty,
          values.faculty.name
        ).then((res) => {
          addBookData.faculty = res.link;
        });
      }

      uploadToS3(
        "public",
        values.cover_photo,
        values.cover_photo.name
      ).then((data) => {
        addBookData.cover_photo = data.link;
        uploadToS3("pdf", values.pdf, values.pdf.name).then((res) => {
          addBookData.number_of_pages = res.numPages;
          addBookData.pdf = res.link;
          dispatch(addBookRequest(addBookData));
        });
      });
    } else {
      let editedData =
        certificate_title || credits
          ? _.omit(
              {
                ...values,
                certificate_attributes: {
                  certificate_description,
                  certificate_title,
                  credit_type,
                  credits,
                  submission_date
                }
              },
              [
                "certificate_description",
                "certificate_title",
                "credit_type",
                "credits",
                "submission_date",
                "certificate",
                "has_subscribers",
                "publish_students",
                "publish_authors",
                "published"
              ]
            )
          : _.omit(
              {
                ...values,
                certificate_attributes: {
                  _destroy: true,
                  id: singleBook?.certificateId
                }
              },
              [
                "certificate_description",
                "certificate_title",
                "credit_type",
                "credits",
                "submission_date",
                "certificate",
                "has_subscribers",
                "publish_students",
                "publish_authors",
                "published"
              ]
            );

      editedData = { ...editedData, publish_state: publishStatus };

      //Book Samples Upload,Ensure updateBookSamples completes before proceeding
      const updatedSamples = await Promise.all(
        editedData.book_samples_attributes.map(async (sample) => {
          if (sample._destroy) {
            return { _destroy: true, id: sample.id };
          }
          try {
            if (sample.file) {
              const result = await uploadToS3(
                "public",
                sample.file,
                sample.file.name
              );
              return { sample_url: result.link };
            }
            return sample;
          } catch (error) {
            console.error(
              `Failed to upload ${sample.sample_url} to S3:`,
              error
            );
            return sample; // Return the original sample in case of error
          }
        })
      );

      // Update book_samples_attributes with the processed samples
      editedData.book_samples_attributes = updatedSamples;
      // Book cover upload
      editedData.cover_photo =
        typeof editedData.cover_photo === "string"
          ? editedData.cover_photo
          : await uploadToS3(
              "public",
              editedData.cover_photo,
              editedData.cover_photo.name
            ).then((data) => data.link);

      //Front Matter upload
      editedData.front_matter =
        typeof editedData.front_matter === "string"
          ? editedData.front_matter
          : values.front_matter
          ? await uploadToS3(
              "public",
              values.front_matter,
              values.front_matter.name
            ).then((res) => res.link)
          : null;

      // Faculty upload
      editedData.faculty =
        typeof editedData.faculty === "string"
          ? editedData.faculty
          : values.faculty
          ? await uploadToS3(
              "public",
              values.faculty,
              values.faculty.name
            ).then((res) => res.link)
          : null;

      // Book pdf upload
      if (singleBook.published) {
        editedData = _.omit(editedData, ["pdf", "number_of_pages"]);
      } else {
        console.log("editedData.pdf else", editedData.pdf);

        editedData.pdf =
          typeof editedData.pdf === "string"
            ? editedData.pdf
            : await uploadToS3(
                "pdf",
                editedData.pdf,
                editedData.pdf.name
              ).then((res) => {
                editedData.number_of_pages = res.numPages;
                return res.link;
              });
      }

      await dispatch(
        editBookRequest({ data: editedData, id: singleBook.id })
      );
    }
  };
  const {
    books: {
      addBook,
      editBook,
      bookTitle,
      bookAuthor,
      bookPrice,
      bookBrief,
      bookVersion,
      bookOlderVersion,
      bookEdition,
      bookIsbn,
      isBookFeatured,
      bookReleaseDate,
      submissionDate,
      publishStatus,
      booksCoverDimensions,
      uploadBookCover,
      uploadBookPdf,
      uploadFontMatterPdf,
      uploadFacultyPdf,
      editorNameLabel,
      editorImage,
      addAnotherEditor,
      addEditors,
      editorJobTitle,
      deleteEditorTitle,
      deleteEditorMessage
    },
    categories,
    certificate: {
      certificateCredits,
      certificateType,
      certificateTitle,
      certificateDescription,
      certificateSectionTitle,
      hintCertificate,
      hintCertificateCredit
    }
  } = messages[lang];

  const handlePreviewSrc = (src) => {
    setBookCoverPreview(src);
  };

  const handleCategoryChange = async (id) => {
    const params = {
      category_id: id,
      lookup: true
    };
    await dispatch(getBooksRequest(params));
  };
  const [idEditor, setIdEditor] = useState(0);

  const deleteEditor = () => {
    if (formRef.current) {
      const oldEditors = [
        ...formRef.current?.values.senior_editors_attributes
      ];
      if (!Array.isArray(oldEditors)) return;
      const editorTobeRemovedIndex = oldEditors.findIndex(
        (editor) =>
          editor.id === idEditor || editor.id_local === idEditor
      );
      if (editorTobeRemovedIndex > -1) {
        // local editor
        const editorTobeRemoved = oldEditors[editorTobeRemovedIndex];
        if (editorTobeRemoved.id_local) {
          oldEditors.splice(editorTobeRemovedIndex, 1);
        }
        // editor from database
        if (editorTobeRemoved.id) {
          oldEditors.splice(editorTobeRemovedIndex, 1, {
            ...editorTobeRemoved,
            _destroy: true
          });
        }
        formRef.current.setFieldValue(
          "senior_editors_attributes",
          oldEditors
        );
      }
    }
    setIdEditor(0);
  };
  return (
    <div>
      <DeleteModal
        handleDelete={deleteEditor}
        deleteTitle={deleteEditorTitle}
        deleteMessage={deleteEditorMessage}
        handleCancel={() => setIdEditor(0)}
        isOpen={!!idEditor}
      />
      <div className="mb-4">
        <Typography variant="h4" component="h1">
          {mode === "add" ? addBook : editBook}
        </Typography>
      </div>
      <div className={styles.wrapper}>
        <Formik
          innerRef={formRef}
          initialValues={
            mode === "add"
              ? getInitialValues()
              : getInitialValues(singleBook)
          }
          onSubmit={handleSubmit}
          validationSchema={ADD_BOOK_SCHEMA(lang)}
          enableReinitialize
        >
          {({ setFieldValue, errors, values }) => {
            console.log("values", values);
            console.log("errors", errors);

            return (
              <Form>
                <Grid container spacing={3}>
                  <Grid item xs={6} className="pb-0">
                    <Input
                      name="title"
                      label={bookTitle}
                      isRequired={true}
                    />
                    <Input
                      name="author"
                      label={bookAuthor}
                      isRequired={true}
                    />
                    <CustomSelect
                      options={categoriesOptions}
                      placeholder={categories.title}
                      disabled={
                        singleBook?.has_older_version ||
                        singleBook?.deprecation === "pending"
                      }
                      name="category_id"
                      bgColor={theme.palette.primary.light}
                      isRequired={true}
                      handleSelectChange={(id) => {
                        handleCategoryChange(id);
                        setFieldValue("old_version_id", "");
                      }}
                    />
                    {mode === "edit" && (
                      <p>
                        Regarding PayPal policy: Existing subscribers
                        are billed the new price only after a 10-day
                        prior email pre-notification, billing cycles
                        within ten days of the price change are not
                        changed until the next billing cycle.
                      </p>
                    )}

                    <Input
                      name="price"
                      isDisabled={
                        singleBook?.deprecation === "pending"
                      }
                      label={bookPrice}
                      isRequired={true}
                      min={1}
                      inputShape="currency"
                    />
                    <Input
                      isRequired={true}
                      name="book_version"
                      type="number"
                      isNumber={true}
                      label={bookVersion}
                    />
                    <div className={styles.relativeContainer}>
                      <Field
                        disabled={
                          singleBook?.has_older_version ||
                          (mode === "edit" &&
                            !singleBook?.has_older_version)
                        }
                        component="select"
                        placeholder={bookOlderVersion}
                        name="old_version_id"
                        className={`form-control ${styles.selectField}`}
                      >
                        <option value="" selected disabled hidden>
                          {bookOlderVersion}
                        </option>
                        <option value="">none</option>
                        <option disabled></option>

                        {booksInCategoryOptions.length > 0 ? (
                          booksInCategoryOptions?.map((book) => {
                            return (
                              <>
                                <option key={book.id} value={book.id}>
                                  {book.label}
                                </option>
                                <option disabled></option>
                              </>
                            );
                          })
                        ) : (
                          <option key={0} disabled>
                            No option
                          </option>
                        )}
                      </Field>
                    </div>
                    <Input
                      name="edition"
                      type="number"
                      isNumber={true}
                      label={bookEdition}
                    />
                    <Input
                      name="isbn"
                      label={bookIsbn}
                      isRequired={true}
                    />
                  </Grid>
                  <Grid item xs={6} className="pb-0">
                    <div className="d-flex flex-column align-items-center text-center">
                      <div className="mb-3 d-flex flex-column align-items-center">
                        <BookCover src={bookCoverPreview} size="sm" />
                        <small className="d-inline-block mt-4">
                          {booksCoverDimensions}
                        </small>
                      </div>
                      <Upload
                        label={uploadBookCover}
                        name="cover_photo"
                        accept="image/*"
                        isImage={true}
                        setFieldValue={setFieldValue}
                        handlePreviewSrc={handlePreviewSrc}
                        isRequired={true}
                      />
                    </div>
                    <Input
                      name="brief"
                      label={bookBrief}
                      inputShape="textarea"
                      showCounter={true}
                      charLimit={800}
                      isRequired={true}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <DatePicker
                      value={values.release_date}
                      placeholder={bookReleaseDate}
                      setFieldValue={setFieldValue}
                      name="release_date"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Upload
                      label={uploadBookPdf}
                      name="pdf"
                      setFieldValue={setFieldValue}
                      accept="application/pdf"
                      isShowName={true}
                      isRequired={true}
                      initialFileData={{
                        type: "book_pdf",
                        isLinkLocal: values?.pdf instanceof File,
                        link: singleBook?.pdf,
                        name: singleBook?.title
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Checkbox
                      name="is_featured"
                      label={isBookFeatured}
                    />
                  </Grid>
                  <Grid container spacing={2} xs={6}>
                    <Switch
                      name="published"
                      label={publishStatus}
                      disabled={
                        singleBook?.published &&
                        singleBook?.has_subscribers
                      }
                    />
                    <Checkbox
                      name="publish_authors"
                      label={"Authors"}
                      disabled={!values?.published}
                    />
                    <Checkbox
                      name="publish_students"
                      label={"Students"}
                      disabled={!values?.published}
                    />
                    <div
                      style={{
                        color: "#b70020",
                        fontSize: "0.9rem",
                        fontWeight: "lighter"
                      }}
                    >
                      {errors["publish_authors_publish_students"]}
                    </div>
                  </Grid>
                </Grid>
                <hr className="my-4" />

                <div>
                  <Typography
                    variant="h6"
                    component="h3"
                    className="mb-4"
                  >
                    {"Samples of Book "}
                  </Typography>
                  <p className="mb-4">
                    samples of book are some pages to being display at
                    book profile
                  </p>
                  <Grid container>
                    <Upload
                      ref={SamplesRef}
                      id={"sss"}
                      isMultiple={true}
                      accept="image/*"
                      onChange={(e) => handleChange(e)}
                      isRequired={true}
                      label={"Upload Samples of Book"}
                      name={"book_samples_attributes"}
                    />
                  </Grid>
                  <Grid container>
                    {samplesArray?.map((sample, index) => {
                      if (sample?._destroy) return null;
                      return (
                        <div
                          key={sample?.id || index}
                          className={styles["SingleSampleDiv"]}
                        >
                          <img
                            src={getLocalORPublicSrc(
                              sample?.sample_url
                            )}
                            alt={"sample"}
                          />
                          <CancelIcon
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              RemoveImgOfSamplesHandler(index)
                            }
                          />
                        </div>
                      );
                    })}
                  </Grid>
                </div>
                {/* new section */}

                <hr className="mb-5" />
                <Grid container>
                  <Grid container>
                    <Upload
                      label={uploadFontMatterPdf}
                      name="front_matter"
                      accept="application/pdf"
                      isShowName={true}
                      setFieldValue={setFieldValue}
                      initialFileData={{
                        type: "front_matter",
                        link: singleBook?.front_matter,
                        name: singleBook?.title
                      }}
                    />
                  </Grid>

                  <Grid item>
                    <Upload
                      label={uploadFacultyPdf}
                      name="faculty"
                      accept="application/pdf"
                      isShowName={true}
                      setFieldValue={setFieldValue}
                      initialFileData={{
                        type: "faculty",
                        link: singleBook?.faculty,
                        name: singleBook?.title
                      }}
                    />
                  </Grid>
                  <Grid container>
                    <FieldArray name="senior_editors_attributes">
                      {(arrayHelpers) => {
                        return (
                          <Grid container>
                            {values?.senior_editors_attributes
                              ?.map((editor, index) => {
                                if (editor?._destroy)
                                  return undefined;
                                return (
                                  <Grid
                                    container
                                    spacing={2}
                                    sx={{ width: "100%", margin: 0 }}
                                    key={index}
                                  >
                                    <div
                                      style={{
                                        margin: "0 auto",
                                        backgroundColor: "#f3f6fc",
                                        height: "2px",
                                        width: "90%"
                                      }}
                                    />

                                    <Grid item xs={4}>
                                      <Input
                                        name={`senior_editors_attributes[${index}].name`}
                                        label={editorNameLabel}
                                      />
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Input
                                        label={editorJobTitle}
                                        name={`senior_editors_attributes[${index}].title`}
                                      />
                                    </Grid>
                                    <Grid item>
                                      <UploadImg
                                        name={`senior_editors_attributes[${index}].photo`}
                                        accept="image/*"
                                        label={editorImage}
                                        isImage={true}
                                        setFieldValue={setFieldValue}
                                        isMultiple={false}
                                        isPublic={true}
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: "10px"
                                      }}
                                    >
                                      <img
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          borderRadius: "25px",
                                          objectFit: "cover"
                                        }}
                                        src={getLocalORPublicSrc(
                                          values
                                            ?.senior_editors_attributes[
                                            index
                                          ]?.photo
                                        )}
                                        alt="Preview"
                                      />
                                      <Grid
                                        item
                                        style={{
                                          display: "flex",
                                          marginLeft: "3px"
                                        }}
                                      >
                                        <CancelIcon
                                          sx={{
                                            width: "30px",
                                            height: "30px"
                                          }}
                                          onClick={() => {
                                            setIdEditor(
                                              values
                                                ?.senior_editors_attributes[
                                                index
                                              ]?.id ??
                                                values
                                                  ?.senior_editors_attributes[
                                                  index
                                                ]?.id_local
                                            );
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                );
                              })
                              .filter(Boolean)}

                            <Button
                              className=""
                              style={{ marginBottom: "20px" }}
                              text={
                                values?.senior_editors_attributes?.filter(
                                  (editor) => !editor?._destroy
                                )?.length > 0
                                  ? addAnotherEditor
                                  : addEditors
                              }
                              onClick={() =>
                                arrayHelpers.push({
                                  id_local: Date.now(),
                                  name: "",
                                  title: "",
                                  photo: userPhoto,
                                  _destroy: false
                                })
                              }
                            />
                          </Grid>
                        );
                      }}
                    </FieldArray>
                  </Grid>

                  <Grid container>
                    <Input
                      label={"Authors number"}
                      name="number_of_authors"
                      type="number"
                      isNumber={true}
                    />
                  </Grid>

                  <Grid container>
                    <Input
                      label={"speckers number"}
                      name="number_of_speakers"
                      type="number"
                      isNumber={true}
                    />
                  </Grid>
                </Grid>

                <hr className="mb-5" />
                <div className="certificate">
                  <Typography
                    variant="h6"
                    component="h3"
                    className="mb-4"
                  >
                    {certificateSectionTitle}
                  </Typography>
                  <p className="m-0">{hintCertificate + ","}</p>
                  <p className="mb-4">{hintCertificateCredit}</p>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <CustomSelect
                        options={CERTIFICATE_TYPES}
                        placeholder={certificateType}
                        name="credit_type"
                        bgColor={theme.palette.primary.light}
                        onChange={(e) => {
                          const { value } = e;
                          setFieldValue("credit_type", value);
                          if (value === "MEDBLEND") {
                            setFieldValue("credits", "");
                            setFieldValue("submission_date", null);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Input
                        name="certificate_title"
                        label={certificateTitle}
                        isRequired={true}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Input
                        name="credits"
                        label={certificateCredits}
                        isRequired={false}
                        isDisabled={
                          values.credit_type === "MEDBLEND"
                            ? true
                            : false
                        }
                        inputShape="currency"
                        currencyPrefix={null}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <DatePicker
                        placeholder={submissionDate}
                        setFieldValue={setFieldValue}
                        name="submission_date"
                        value={values.submission_date}
                        isDisabled={
                          values.credit_type === "MEDBLEND"
                            ? true
                            : false
                        }
                      />
                      <div
                        style={{
                          color: "#b70020",
                          fontSize: "0.8rem"
                        }}
                      >
                        {errors["submission_date"]}
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <Input
                        name="certificate_description"
                        label={certificateDescription}
                        inputShape="textarea"
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className="d-block mt-3">
                  <Button
                    text={mode === "add" ? addBook : editBook}
                    className="primary-lg"
                    type="submit"
                  />
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default BookForm;
